import Vue from 'vue';
import section from '@/payloads/section.json';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import { editHistory } from '@/mixins/history';
import _ from 'lodash';
import TreeHelper from './_tree-helper';

export default Vue.component('blocks-container', {
  template: require('./template.html'),
  mixins: [guid, editHistory],
  components: {
    // state helper for dragging droplets around
    TreeHelper,
  },
  name: 'blocks-container',
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
    ]),
    getWidth() {
      let width = '100%';
      if (this.viewport === 'mobile') {
        width = '600px';
      }
      if (this.viewport === 'tablet') {
        width = '992px';
      }
      return width;
    },
  },
  data() {
    const renderKey = Date.now();
    return {
      renderKey,
      blockTypes: ['section'],
    };
  },
  watch: {
    'currentPage.blocks': function watchBlocks() {
      // bouncing the component key will force a re-render. This is needed
      // for dragula to re insert the draggable container. See @/directives/main.js
      this.renderKey = Date.now();
    },
  },
  methods: {
    addBlock(i) {
      const newSection = _.cloneDeep(section);
      newSection._id = this.guid();
      newSection.createdDate = new Date().toISOString();
      const payload = {
        index: i, // pass current index, so we can reference where to place new
        newSection,
      };
      if (this.currentPage.type === 'template') {
        payload.newSection.templateRegion = true;
      }
      this.$store.dispatch('addContentBlock', payload);
      this.setEditHistory({
        type: 'add_section',
        meta: {
          dropletType: newSection.type,
        },
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/blocks-container/index.js